import React, { memo } from 'react';

const AvoidDuplicatesIcon = ({ color = '#335B70' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
        >
            <defs>
                <path
                    id="avoid-duplicates-a"
                    d="M32 18.668A9.5 9.5 0 1018.668 32H0V0h32v18.668zm0 11.664V32h-1.668A9.557 9.557 0 0032 30.332z"
                />
                <path
                    id="avoid-duplicates-c"
                    d="M25.404 30.317c.08-.377.08-8.812 0-26 .377-2.697 2.205-4.062 4-4 .99.085 5.235.068 13 0 .362-.005-42.537.147-42 0 .457.604.848.888 1 1l8 8v1c.174 13.414.174 19.75 0 20 .049 2.408 41.922 3.756 40 4h-20c-1.868.148-3.723-1.297-4-4z"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <mask id="avoid-duplicates-b" fill="#fff">
                    <use xlinkHref="#avoid-duplicates-a" />
                </mask>
                <g mask="url(#avoid-duplicates-b)">
                    <g transform="translate(15.596 -.317)">
                        <mask id="d" fill="#fff">
                            <use xlinkHref="#avoid-duplicates-c" />
                        </mask>
                        <g
                            fill="#FAFBFC"
                            stroke="#3C4248"
                            strokeWidth="0.941"
                            mask="url(#avoid-duplicates-d)"
                        >
                            <path d="M14.445 29.304H-4.473c-.69.08-1.053-.196-1.093-.83-.04-.632-.04-9.39 0-26.273.062-.592.426-.87 1.093-.833.655.035 4.721.018 12.199-.05.129-.002.272.045.424.116.101.048.201.122.3.223l6.937 7.127c.023 12.641.023 19.205 0 19.69-.022.487-.336.763-.942.83z" />
                        </g>
                    </g>
                    <g stroke="#3C4248" strokeWidth="0.941">
                        <path
                            fill="#FAFBFC"
                            d="M21.041 30.986H2.122c-.688.08-1.052-.195-1.092-.828-.04-.634-.04-9.392 0-26.274.061-.592.425-.87 1.092-.833.656.035 4.722.018 12.2-.051.129-.001.272.046.424.117.101.048.201.122.3.223l6.937 7.127c.023 12.641.023 19.205 0 19.69-.022.487-.336.763-.942.83z"
                        />
                        <path d="M13.941 2.886v6.116c.163.951.633 1.422 1.41 1.412.776-.01 2.816-.005 6.12.015M23 1v6.116c.163.951.632 1.422 1.409 1.413.777-.01 2.817-.005 6.12.014" />
                    </g>
                </g>
                <path
                    fill="#3C4248"
                    d="M24.526 17.052a7.358 7.358 0 00-7.363 7.363 7.358 7.358 0 007.363 7.364 7.358 7.358 0 007.363-7.364 7.358 7.358 0 00-7.363-7.363zm1.229 7.363l2.979 2.98-1.23 1.228-2.978-2.979-2.979 2.979-1.229-1.229 2.98-2.979-2.98-2.979 1.23-1.228 2.978 2.978 2.979-2.978 1.229 1.228-2.98 2.98z"
                />
            </g>
        </svg>
    );
};

export default memo(AvoidDuplicatesIcon);
